import { render, staticRenderFns } from "./OilTempList.vue?vue&type=template&id=3c2285ee"
import script from "./OilTempList.vue?vue&type=script&lang=js"
export * from "./OilTempList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports